class DetailsDisclosure extends HTMLElement {
  constructor() {
    super()
    this.mainDetailsToggle = this.querySelector('details')
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this))
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this))
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close()
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations()

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play())
    } else {
      this.animations.forEach((animation) => animation.cancel())
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false)
  }
}

customElements.define('details-disclosure', DetailsDisclosure)

class HeaderMenu {
  constructor() {
    this.header = document.querySelector('.header-wrapper')
    this.megaMenus = document.querySelectorAll('.mega-menu')
    const closeMenuButton = document.querySelectorAll('.close-mega-menu')

    this.megaMenus.forEach((menu) => {
      const content = document.getElementById(menu.getAttribute('aria-controls'))
      setTimeout(() => content.classList.remove('hidden'), 0)

      menu.addEventListener('click', () => this.toggleMenu(menu, content))
      menu.addEventListener('keydown', (event) => {
        if (['Enter', ' '].includes(event.key)) {
          event.preventDefault()
          this.toggleMenu(menu, content)
        }
      })

      content.addEventListener('focusout', (event) => {
        if (!content.contains(event.relatedTarget)) {
          this.closeMenu(menu, content)
        }
      })
    })

    document.addEventListener('click', (event) => {
      if (!this.header.contains(event.target)) {
        this.closeAllMenus()
      }
    })
    closeMenuButton.forEach((button) => {
      button.addEventListener('click', () => {
        this.closeAllMenus()
      })
    })
  }

  toggleMenu(menu, content) {
    const isExpanded = menu.getAttribute('aria-expanded') === 'true'
    if (!isExpanded) this.closeAllMenus()

    menu.setAttribute('aria-expanded', !isExpanded)
    content.setAttribute('aria-hidden', isExpanded)
    this.updateHeaderClass()
    this.setTabIndex(content, !isExpanded)
  }

  closeMenu(menu, content) {
    menu.setAttribute('aria-expanded', 'false')
    content.setAttribute('aria-hidden', 'true')
    this.setTabIndex(content, true)
    this.updateHeaderClass()
  }

  closeAllMenus() {
    this.megaMenus.forEach((menu) => {
      const content = document.getElementById(menu.getAttribute('aria-controls'))
      this.closeMenu(menu, content)
    })
  }

  setTabIndex(content, isHidden) {
    content
      .querySelectorAll('a')
      .forEach((link) => link.setAttribute('tabindex', isHidden ? '0' : '-1'))
  }

  updateHeaderClass() {
    const anyExpanded = [...this.megaMenus].some(
      (menu) => menu.getAttribute('aria-expanded') === 'true'
    )
    this.header.classList.toggle('menu-expanded', anyExpanded)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeaderMenu()
})
